import React, { useState, useEffect } from 'react'
import { triggerClevertap, httpAxios, getCommonClevertapParams } from 'AccountsUtils'
import DesktopModal from '../DesktopModal'
import LinkInput from '../LinkInput'

const sendEmail = (href, email, setEmailerSuccessModal,
  setToggleModal, setError, tripId, emailerText) => {
  const clevertapData = { ...getCommonClevertapParams(),
    current_page_name: 'trip details',
    last_page_name: 'account',
    email,
    trip_ID: tripId }
  triggerClevertap('account', { ...clevertapData, 'event type': `resend_${emailerText}_clicked` })
  httpAxios(`${href}${email}`).then(resp => {
    if (resp && resp.data && resp.data.toLowerCase() === 'success') {
      setEmailerSuccessModal(true)
    }
    if (resp && resp.data && resp.data.toLowerCase() === 'failure') {
      setError(true)
      setEmailerSuccessModal(true)
    }
  }).catch(() => {
    setToggleModal(false)
    setEmailerSuccessModal(false)
  })
}

const Emailer = props => {
  const { emailerText, href, toggleModal, setToggleModal,
    emailerSuccessModal, setEmailerSuccessModal, tripId } = props
  const [error, setError] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    if (error) {
      setErrorMsg('Oops! There was a technical issue. This is usually temporary, please try again in sometime')
    }
  }, [emailerSuccessModal])

  return (
    <React.Fragment>
      <If condition={toggleModal}>
        <DesktopModal
          showFlag={toggleModal}
          onCloseModal={() => {
            setToggleModal(false)
            setEmailerSuccessModal(false)
          }}
          header={`Resend ${emailerText}`}
        >
          <div>
            <If condition={!emailerSuccessModal}>
              <p className="fs-11 c-grey-70 py-3">Confirm the email Id where {emailerText} will be sent to</p>
              <LinkInput
                callbackFn={
                  email => sendEmail(href, email, setEmailerSuccessModal,
                    setToggleModal, setError, tripId, emailerText)
                }
                defaultEmail=""
                inputType="input_only"
                validator={input => /(.+)@(.+){2,}\.(.+){2,}/.test(input)}
                fieldName="Email Id"
                liClass="flex flex-center"
                tripId={tripId}
              />
            </If>
            <If condition={emailerSuccessModal}>
              <p className="fs-11 c-grey-70 py-3">{ !error ? `A copy of the ${emailerText} has been sent to the Email ID` : errorMsg}</p>
            </If>
          </div>
        </DesktopModal>
      </If>
    </React.Fragment>
  )
}

export default Emailer
